import * as React from "react"
import {Grid} from "@mui/material";

import {isSystemBusy} from "@signals";
import {PRODUCT_PAGE_ROUTES} from "@constants";
import PageWrapper from "Pages/@PageWrapper"
import { TourProvider, TourTarget } from "@tour"
import {productPagesDetailsIsEmpty} from "./@signals";
import ProductPagesFilters from "./Filters";
import DigitalShelfProductPagesTable from "./Table";
import ProductPagesDetailsModal from "./ShowDetails";
import {useEffect} from "react";
import ProductPageDetailsReportFormDrawer from "./ReportForm";
import ProductPageDetailsLegend from "./Legend";


export default function ProductPageDetailsPage() {

    useEffect(() => {
        return () => productPagesDetailsIsEmpty.value = false
    }, []);

    return <PageWrapper
        tourPageKey="productPageDetails"
        head={`DIP Insight | ${PRODUCT_PAGE_ROUTES.DETAILS_TITLE}`}
        title={PRODUCT_PAGE_ROUTES.DETAILS_TITLE}
        subtitle={PRODUCT_PAGE_ROUTES.DETAILS_SUBTITLE}
        isEmpty={productPagesDetailsIsEmpty.value}
        filters={<ProductPagesFilters />}
        hasErrors={isSystemBusy.value}
    >
        <Grid container spacing={4} sx={{ pt: 6 }}>
            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="pp-details-table" height={450} />
                <DigitalShelfProductPagesTable />
                <ProductPageDetailsLegend />
            </Grid>
        </Grid>

        <ProductPagesDetailsModal />

        <Grid item xs={12}>
            <ProductPageDetailsReportFormDrawer />
        </Grid>

    </PageWrapper>
}